import * as CSS from "csstype";
import { Box, CircularProgress, styled, Typography } from "@mui/material";

export const TEXT_ELLIPSIS: CSS.Properties = {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
};

export const TEXT_ELLIPSIS_AFTER_TWO_LINES: CSS.Properties = {
    WebkitLineClamp: "2",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
};

export const BOX_SHADOWS = {
    ELEVATION_0: {
        boxShadow:
            "rgba(0, 0, 0, 0.04) 0px 5px 22px, rgba(0, 0, 0, 0.03) 0px 0px 0px 0.5px;",
    },
    ELEVATION_1: {
        boxShadow:
            "0px 1px 2px rgba(0, 0, 0, 0.3), 0px 1px 3px 1px rgba(0, 0, 0, 0.15)",
    },
    ELEVATION_2: {
        boxShadow:
            "0px 1px 2px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)",
    },
    ELEVATION_3: {
        boxShadow:
            "0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)",
    },
    ELEVATION_4: {
        boxShadow:
            "0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)",
    },
    ELEVATION_5: {
        boxShadow:
            "0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)",
    },
};

export function determineDefaultBackgroundColor(
    isDefaultBackgroundColor?: boolean,
) {
    return !isDefaultBackgroundColor
        ? "var(--community-color-snow-white)"
        : "var(--community-header-background-color)";
}

export const ButtonTypography = styled(Typography)({
    fontWeight: "500",
    "@media (max-width: 400px)": {
        fontSize: "12px",
    },
});

export const CTA_BUTTONS_STYLES = {
    height: "40px",
    padding: "0 16px",
    borderRadius: "90px",
    fontWeight: "500",
    fontSize: "14px",
    "@media (min-width: 640px)": {
        height: "48px",
        padding: "0 24px",
    },
};

export const BUTTONS_BASE_STYLES = {
    height: "32px",
    padding: "0 8px",
    borderRadius: "90px",
    fontWeight: "500",
    fontSize: "14px",
    "@media (min-width: 640px)": {
        height: "32px",
        padding: "0 8px",
    },
};

export const BUTTONS_WITH_ICON_STYLES = {
    height: "32px",
    padding: "0 16px",
    borderRadius: "90px",
    fontWeight: "500",
    fontSize: "14px",
};

export const CommunityCircularProgress = styled(CircularProgress)({
    color: "var(--community-color-light-steal-blue)",
});

export const TippspielTitleTypography = styled(Typography)({
    fontSize: "1.125rem",
    fontWeight: 400,
    color: "var(--community-color-secondary-text)",
    marginBottom: "16px",
});

export const TippspielLinkTypography = styled(Typography)({
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: "0.5",
    color: "rgb(0, 94, 168)",
    cursor: "pointer",
});

export const PostFormInputTriggerButton = styled(Box, {
    shouldForwardProp: (prop) => prop !== "isActive",
})<{ isActive?: boolean }>(({ isActive }) => ({
    display: "flex",
    cursor: "pointer",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
    width: "max-content",
    height: "32px",
    borderRadius: "90px",
    padding: "0 12px",
    backgroundColor: isActive
        ? "var(--community-color-light-steal-blue)"
        : "var(--community-color-transparent-black-05)",
    "& > svg": {
        width: "16px",
        height: "16px",
    },
    "& > p": {
        fontSize: "14px",
        fontWeight: "500",
        color: isActive
            ? "var(--community-color-snow-white)"
            : "var(--community-color-primary-text)",
    },
}));
